<template>
    <div class="service-report">
        <div class="row">
            <div class="col-md-6">
                <report-logins v-bind:context="report.product" v-bind:year="year"
                               v-bind:monthName="monthName"></report-logins>
            </div>
            <div class="col-md-6">
                <report-pageviews v-bind:context="report.product" v-bind:year="year"
                                  v-bind:monthName="monthName"></report-pageviews>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col-md-12">
                    <report-calls v-bind:services="report.clientHasServices"
                                  v-bind:calls="report.services.calls"></report-calls>
                </div>
                <div class="col-md-12">
                    <report-enquiries v-bind:services="report.clientHasServices"
                                  v-bind:enquiries="report.services.enquiries"></report-enquiries>
                </div>
                <div class="col-md-12">
                    <report-healthchecks v-bind:services="report.clientHasServices"
                                      v-bind:healthchecks="report.services.healthchecks"></report-healthchecks>
                </div>
                <div class="col-md-12">
                    <report-downloads v-bind:services="report.clientHasServices"
                                      v-bind:downloads="report.services.downloads"></report-downloads>
                </div>
                <div class="col-md-12" v-if="report.services.apps">
                    <report-apps v-bind:apps="report.services.apps"></report-apps>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportServices",
        props: ['report', 'year', 'month', 'monthName'],
        data() {
            return {
            }
        }
    }
</script>

<style scoped>

</style>
